<template>
  <div v-if="progressId">
    <div class="progress">
      <div
        class="progress-bar progress-bar-striped progress-bar-success"
        role="progressbar"
        :aria-valuenow="'test'"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="`width:${data.percent}%`"
      >
        {{ status }} ({{ data.percent }}%)
      </div>
    </div>
    <div class="overlay" />
  </div>
</template>

<script>
/**
 * @class ProgressBar
 *
 * @description progress bar component
 */
import listRestMixin from '../utils/mixin-list-rest'
import { get } from 'lodash'

export default {
  name: 'progressBar',
  mixins: [listRestMixin],
  data() {
    return {
      data: {
        percent: 0,
      },
      finished: false,
      progressId: null,
      time: 1000,
    }
  },
  computed: {
    mongoId() {
      return this.$get('mongoId')
    },
    mongoList() {
      return this.$get('mongoList')
    },
    queryId() {
      return this.$get('queryId')
    },
    status() {
      const statuses = {
        in: this.$i18n.t('processing'),
        post: this.$i18n.t('post-processing'),
        done: this.$i18n.t('done'),
      }
      return statuses[this.data.status]
    },
  },
  async created() {
    await this.getProgressId()
    await this.refresh()
  },
  methods: {
    async getData() {
      const response = await this.$client.execute({
        operationId: 'Progress_filterProgressId',
        parameters: {
          progressId: this.progressId,
        },
        method: 'get',
      })
      this.data = response.body
    },
    getId() {
      const collection = get(this.mongoList, 'collection', '').toLowerCase()
      return collection || this.mongoId || this.queryId || null
    },
    async getProgressId() {
      const listId = this.getId()
      const { body } = await this.getProgress({
        listId,
        userId: Number(this.$CORE.params.ID_S_USER),
      })
      this.progressId = body && body.progressId ? body.progressId : null
    },
    async refresh() {
      if (this.finished || !this.progressId) return
      await this.getData()
      const response = this.data
      if (!response) return
      if (response.status !== 'done') {
        setTimeout(this.refresh, this.time)
      } else {
        this.finished = true
        window.location.reload()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay {
  background-color: #efefef;
  position: absolute;
  width: 100%;
  height: 95%;
  z-index: 1000;
  top: 35px;
  left: 0px;
  opacity: 0.5; /* in FireFox */
  filter: alpha(opacity=50); /* in IE */
}
</style>
